import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useState, useEffect } from "react";
import Axios from "../../../api/Axios";
import storage from "../../../Services/Storage";
import { toast } from "react-toastify";
// import { ProgressSpinner } from "primereact/progressspinner";
import Loader from "../../../Components/Loader";

const url = "FieldLevelSetting/";
const GetFiled_url = `${url}GetFieldData?`;
const SaveField_url = `${url}SaveAllUserGroupData?`;

const FieldLevelSettings = () => {
    const auth = storage.getLocal("user");
    const [fieldData, setFieldData] = useState([]);
    console.log("fieldData", fieldData);
    const [selectedFields, setSelectedFields] = useState([]);
    console.log("selectedFields", selectedFields);
    const [isLoading, setIsLoading] = useState(true);

    const getFieldLevel = async () => {
        setIsLoading(true);
        try {
            const Field_Url = `${GetFiled_url}CompId=${auth.CompId}`;
            const response = await Axios.get(Field_Url);
            const data = response.data.Data || [];

            // Auto-select rows where ISREADONLY is "Y"
            const preSelected = data.filter((field) => field.ISREADONLY === "Y");
            setFieldData(data);
            setSelectedFields(preSelected);
        } catch (error) {
            toast.error("Something Went Wrong. Please Contact Helpdesk.", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getFieldLevel();
    }, []);

    const handleSelectionChange = (e) => {
        setSelectedFields(e.value);
    };

    const handleSave = async () => {
        const payload = {
            listModelsaveField: selectedFields.map((field) => ({
                pvcid: field.ID.toString(),
                pvccompid: field.COMP_ID,
                pvcpagename: field.PAGE_NAME,
                pvcfieldname: field.FIELD_NAME,
                pvcenable: "Y",
            })),
        };

        try {
            const res = await Axios.post(SaveField_url, payload);
            if(res.data.IsSaved === false){
                toast.error("Error occured while saving the data", {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                    closeButton :false
                });
            }
            else{
                toast.success("Field settings saved successfully!", {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                    closeButton :false
                });
            }
        } catch (error) {
            toast.error("Failed to save settings. Please try again.", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000,
            });
            console.error(error);
        }
    };
    return (
        <>
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Field Level Settings</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="text-end mb-2">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleSave}
                                disabled = {selectedFields.length==0}
                            >
                Save
                            </button>
                        </div>
                    </div>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12">
                    {isLoading ? (
                        <Loader />
                    ) : (
                        <div className="DataTable">
                            <DataTable
                                value={fieldData}
                                rows={10}
                                filterDisplay="row"
                                // showGridlines
                                stripedRows
                                scrollHeight="80vh"
                                paginator
                                scrollable
                                selection={selectedFields}
                                onSelectionChange={handleSelectionChange}
                                selectionMode="checkbox"
                            >
                                <Column
                                    selectionMode="multiple"
                                    header="Select All"
                                    headerStyle={{ width: "8rem" }}
                                ></Column>
                                <Column field="PAGE_NAME" header="Page Name" />
                                <Column field="FIELD_NAME" header="Field Name" />
                            </DataTable>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default FieldLevelSettings;
